module.exports = __webpack_public_path__ + "static/media/Dec503.67c4b561.tsx";